import React, {useState} from 'react';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const NetworkEngineerFilter = ({
                                   applyFilter,
                                   roleId
                               }) => {
    const filterInputs = {
        client_name: '',
        eng_name: '',
        to_date: '',
        from_date: ''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
            }}
        >
            <ConstantInput
                label={localization.clientName}
                value={filterFieldsData.client_name}
                regex={Regex.text.test(filterFieldsData.client_name)}
                type="text"
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, client_name: val})
                }
            />
            {roleId === 16 &&
                <ConstantInput
                    label={localization.enggName}
                    value={filterFieldsData.eng_name}
                    regex={Regex.text.test(filterFieldsData.eng_name)}
                    type="text"
                    handleChange={(val) =>
                        setFilterFieldsData({...filterFieldsData, eng_name: val})
                    }
                />
            }
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, from_date: val})
                }
                label={`From Date`}
                required={false}
            />
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, to_date: val})
                }
                label={`To Date`}
                required={false}
            />

            <br/>
            <br/>
            <br/>
            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src="../images/arrow-right.png" alt=""/>
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        applyFilter(filterInputs);
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default NetworkEngineerFilter;
